import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

function _awaitAsyncGenerator(value) {
  return new _AwaitValue(value);
}

function _wrapAsyncGenerator(fn) {
  return function () {
    return new _AsyncGenerator(fn.apply(this, arguments));
  };
}

function _AsyncGenerator(gen) {
  var front, back;

  function send(key, arg) {
    return new Promise(function (resolve, reject) {
      var request = {
        key: key,
        arg: arg,
        resolve: resolve,
        reject: reject,
        next: null
      };

      if (back) {
        back = back.next = request;
      } else {
        front = back = request;
        resume(key, arg);
      }
    });
  }

  function resume(key, arg) {
    try {
      var result = gen[key](arg);
      var value = result.value;
      var wrappedAwait = value instanceof _AwaitValue;
      Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) {
        if (wrappedAwait) {
          resume(key === "return" ? "return" : "next", arg);
          return;
        }

        settle(result.done ? "return" : "normal", arg);
      }, function (err) {
        resume("throw", err);
      });
    } catch (err) {
      settle("throw", err);
    }
  }

  function settle(type, value) {
    switch (type) {
      case "return":
        front.resolve({
          value: value,
          done: true
        });
        break;

      case "throw":
        front.reject(value);
        break;

      default:
        front.resolve({
          value: value,
          done: false
        });
        break;
    }

    front = front.next;

    if (front) {
      resume(front.key, front.arg);
    } else {
      back = null;
    }
  }

  this._invoke = send;

  if (typeof gen.return !== "function") {
    this.return = undefined;
  }
}

if (typeof Symbol === "function" && Symbol.asyncIterator) {
  _AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
    return this;
  };
}

_AsyncGenerator.prototype.next = function (arg) {
  return this._invoke("next", arg);
};

_AsyncGenerator.prototype.throw = function (arg) {
  return this._invoke("throw", arg);
};

_AsyncGenerator.prototype.return = function (arg) {
  return this._invoke("return", arg);
};

function _AwaitValue(value) {
  this.wrapped = value;
}

function _asyncIterator(iterable) {
  var method;

  if (typeof Symbol !== "undefined") {
    if (Symbol.asyncIterator) {
      method = iterable[Symbol.asyncIterator];
      if (method != null) return method.call(iterable);
    }

    if (Symbol.iterator) {
      method = iterable[Symbol.iterator];
      if (method != null) return method.call(iterable);
    }
  }

  throw new TypeError("Object is not async iterable");
}

import { Buffer } from "buffer";
import { NOISE_MSG_MAX_LENGTH_BYTES, NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG } from "./constants"; // Returns generator that encrypts payload from the user

export function encryptStream(handshake) {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, chunkBuffer, i, end, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 10;
              return _awaitAsyncGenerator(_step.value);

            case 10:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 27;
                break;
              }

              chunk = _value;
              chunkBuffer = Buffer.from(chunk.buffer, chunk.byteOffset, chunk.length);
              i = 0;

            case 15:
              if (!(i < chunkBuffer.length)) {
                _context.next = 24;
                break;
              }

              end = i + NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG;

              if (end > chunkBuffer.length) {
                end = chunkBuffer.length;
              }

              data = handshake.encrypt(chunkBuffer.slice(i, end), handshake.session);
              _context.next = 21;
              return data;

            case 21:
              i += NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG;
              _context.next = 15;
              break;

            case 24:
              _iteratorNormalCompletion = true;
              _context.next = 4;
              break;

            case 27:
              _context.next = 33;
              break;

            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 33:
              _context.prev = 33;
              _context.prev = 34;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 38;
                break;
              }

              _context.next = 38;
              return _awaitAsyncGenerator(_iterator.return());

            case 38:
              _context.prev = 38;

              if (!_didIteratorError) {
                _context.next = 41;
                break;
              }

              throw _iteratorError;

            case 41:
              return _context.finish(38);

            case 42:
              return _context.finish(33);

            case 43:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 29, 33, 43], [34,, 38, 42]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
} // Decrypt received payload to the user

export function decryptStream(handshake) {
  return /*#__PURE__*/function () {
    var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, chunk, chunkBuffer, i, end, _chunk, _yield$_awaitAsyncGen, decrypted, valid;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context2.prev = 2;
              _iterator2 = _asyncIterator(source);

            case 4:
              _context2.next = 6;
              return _awaitAsyncGenerator(_iterator2.next());

            case 6:
              _step2 = _context2.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context2.next = 10;
              return _awaitAsyncGenerator(_step2.value);

            case 10:
              _value2 = _context2.sent;

              if (_iteratorNormalCompletion2) {
                _context2.next = 34;
                break;
              }

              chunk = _value2;
              chunkBuffer = Buffer.from(chunk.buffer, chunk.byteOffset, chunk.length);
              i = 0;

            case 15:
              if (!(i < chunkBuffer.length)) {
                _context2.next = 31;
                break;
              }

              end = i + NOISE_MSG_MAX_LENGTH_BYTES;

              if (end > chunkBuffer.length) {
                end = chunkBuffer.length;
              }

              _chunk = chunkBuffer.slice(i, end);
              _context2.next = 21;
              return _awaitAsyncGenerator(handshake.decrypt(_chunk, handshake.session));

            case 21:
              _yield$_awaitAsyncGen = _context2.sent;
              decrypted = _yield$_awaitAsyncGen.plaintext;
              valid = _yield$_awaitAsyncGen.valid;

              if (valid) {
                _context2.next = 26;
                break;
              }

              throw new Error("Failed to validate decrypted chunk");

            case 26:
              _context2.next = 28;
              return decrypted;

            case 28:
              i += NOISE_MSG_MAX_LENGTH_BYTES;
              _context2.next = 15;
              break;

            case 31:
              _iteratorNormalCompletion2 = true;
              _context2.next = 4;
              break;

            case 34:
              _context2.next = 40;
              break;

            case 36:
              _context2.prev = 36;
              _context2.t0 = _context2["catch"](2);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 40:
              _context2.prev = 40;
              _context2.prev = 41;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context2.next = 45;
                break;
              }

              _context2.next = 45;
              return _awaitAsyncGenerator(_iterator2.return());

            case 45:
              _context2.prev = 45;

              if (!_didIteratorError2) {
                _context2.next = 48;
                break;
              }

              throw _iteratorError2;

            case 48:
              return _context2.finish(45);

            case 49:
              return _context2.finish(40);

            case 50:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 36, 40, 50], [41,, 45, 49]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}